/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface HospitalAftercareFindSimple {
  /** 홈케어 상품 고유 ID */
  _id?: string;
  /** 홈케어 상품 제목 */
  title?: string;
  /** 홈케어 상품 기본 가격 */
  price?: number;
  /** 할인율 계산 방식 정의 */
  saleType?: string;
  /** 홈케어 상품의 정액 할인액 */
  salePrice?: number;
  /** 홈케어 상품의 정률 할인의 할인율 */
  saleRate?: number;
  /** 홈케어 상품 시작 일자 */
  startDate?: string;
  /** 홈케어 상품 종료 일자 */
  endDate?: string;
  /** 홈케어 상품 시작 및 종료시간 설정 여부. */
  isLimitedTime?: boolean;
  /** 홈케어 상품 대표 이미지 fileID */
  representImage?: FilePaths;
  /** 홈케어 상품 조회 건수 */
  viewCount?: number;
  /** 홈케어 상품 구매 상담 채팅 건수 */
  purchaseChatCount?: number;
  /** 홈케어 상품의 활성화 여부 */
  isActive?: boolean;
  /** 홈케어 상품 상단 고정 여부 */
  isPinned?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 병원 ID */
  hospitalID?: string;
}

export interface FilePaths {
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths?: string[];
}

export interface HospitalAftercareFileWriter {
  /** 홈케어 상품 고유 ID */
  _id?: string;
  /** 홈케어 상품 제목 */
  title?: string;
  /** 홈케어 상품 기본 가격 */
  price?: number;
  /** 할인율 계산 방식 정의 */
  saleType?: string;
  /** 홈케어 상품의 정액 할인액 */
  salePrice?: number;
  /** 홈케어 상품의 정률 할인의 할인율 */
  saleRate?: number;
  /** 홈케어 상품 시작 일자 */
  startDate?: string;
  /** 홈케어 상품 종료 일자 */
  endDate?: string;
  /** 홈케어 상품 시작 및 종료시간 설정 여부. */
  isLimitedTime?: boolean;
  /** 한 줄 소개글 */
  description?: string;
  /** 홈케어 상품 대표 이미지 fileID */
  representImage?: File;
  /** 홈케어 상품 상세정보 타입 정의 */
  type?: string;
  /** 상세정보 본문 */
  content?: string;
  /** 상세정보 파일 이미지 fileIDs */
  fileIDs?: File[];
  /** 홈케어 상품 조회 건수 */
  viewCount?: number;
  /** 홈케어 상품 구매 상담 채팅 건수 */
  purchaseChatCount?: number;
  /** 홈케어 상품의 활성화 여부 */
  isActive?: boolean;
  /** 홈케어 상품 상단 고정 여부 */
  isPinned?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 병원 ID */
  hospitalID?: string;
  /** 최초 작성자 ID */
  writerID?: UserNameAndType;
  /** 최종 수정  또는 삭제자 ID */
  modifierID?: UserNameAndType;
  /** 생성일시 */
  createdAt?: string;
  /** 수정일시. */
  modifiedAt?: string;
  /** 수정 또는 삭제일시 */
  updatedAt?: string;
}

export interface File {
  /**
   * 파일 ID
   * @example "66aca461f8238a4fd30abe15"
   */
  _id: string;
  /** 파일의 소유자 ID */
  userID?: string;
  /**
   * 파일 타입
   * - 300: Image
   * - 400: Video
   * - 500: File
   */
  type: number;
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths: string[];
  /** 파일 별, S3 스토리지에 업로드 된 파일의 정보 객체 배열 */
  aws?: Record<string, any>[];
  /** 파일 만료일. 외부 연동 서비스일 경우에 존재 */
  expiredAt?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface UserNameAndType {
  /** 유저 ID */
  _id: string;
  /** 이름 */
  name: string;
  /** 유저의 실제 이름 */
  realName: string;
  /** 유저 타입 */
  type: string;
  /** 유저의 직무 또는 직책 */
  jobType: string;
}

export interface HospitalAftercare {
  /** 홈케어 상품 고유 ID */
  _id?: string;
  /** 홈케어 상품 제목 */
  title?: string;
  /** 홈케어 상품 기본 가격 */
  price?: number;
  /** 할인율 계산 방식 정의 */
  saleType?: string;
  /** 홈케어 상품의 정액 할인액 */
  salePrice?: number;
  /** 홈케어 상품의 정률 할인의 할인율 */
  saleRate?: number;
  /** 홈케어 상품 시작 일자 */
  startDate?: string;
  /** 홈케어 상품 종료 일자 */
  endDate?: string;
  /** 홈케어 상품 시작 및 종료시간 설정 여부. */
  isLimitedTime?: boolean;
  /** 한 줄 소개글 */
  description?: string;
  /** 홈케어 상품 대표 이미지 fileID */
  representImage?: string;
  /** 홈케어 상품 상세정보 타입 정의 */
  type?: string;
  /** 상세정보 본문 */
  content?: string;
  /** 상세정보 파일 이미지 fileIDs */
  fileIDs?: string;
  /** 홈케어 상품 조회 건수 */
  viewCount?: number;
  /** 홈케어 상품 구매 상담 채팅 건수 */
  purchaseChatCount?: number;
  /** 홈케어 상품의 활성화 여부 */
  isActive?: boolean;
  /** 홈케어 상품 상단 고정 여부 */
  isPinned?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 병원 ID */
  hospitalID?: string;
  /** 최초 작성자 ID */
  writerID?: string;
  /** 최종 수정  또는 삭제자 ID */
  modifierID?: string;
  /** 생성일시 */
  createdAt?: string;
  /** 수정일시. */
  modifiedAt?: string;
  /** 수정 또는 삭제일시 */
  updatedAt?: string;
}

export interface HospitalEventFindSimple {
  /** 병원 이벤트 고유 ID */
  _id?: string;
  /** 이벤트 제목 */
  title?: string;
  /** 이벤트 기본 가격 */
  price?: number;
  /** 할인율 계산 방식 정의 */
  saleType?: string;
  /** 이벤트의 정액 할인액 */
  salePrice?: number;
  /** 이벤트의 정률 할인의 할인율 */
  saleRate?: number;
  /** 이벤트 시작 일자 */
  startDate?: string;
  /** 이벤트 종료 일자 */
  endDate?: string;
  /** 이벤트 시작 및 종료시간 설정 여부. */
  isLimitedTime?: boolean;
  /** 한 줄 소개글 */
  description?: string;
  /** 이벤트 대표 이미지 fileID */
  representImage?: FilePaths;
  /** 병원 이벤트 통계 ID */
  stats_HospitalEventID?: StatsHospitalEventBaseCount;
  /** 이벤트의 활성화 여부 */
  isActive?: boolean;
  /** 이벤트 상단 고정 여부 */
  isPinned?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 병원 ID */
  hospitalID?: string;
}

export interface StatsHospitalEventBaseCount {
  /** 병원 이벤트 통계 고유 ID */
  _id?: string;
  /** 조회 수 */
  viewCount?: number;
  /** 상담버튼 클릭 수 */
  chatCount?: number;
}

export interface HospitalEventFileWriter {
  /** 병원 이벤트 고유 ID */
  _id?: string;
  /** 이벤트 제목 */
  title?: string;
  /** 이벤트 기본 가격 */
  price?: number;
  /** 할인율 계산 방식 정의 */
  saleType?: string;
  /** 이벤트의 정액 할인액 */
  salePrice?: number;
  /** 이벤트의 정률 할인의 할인율 */
  saleRate?: number;
  /** 이벤트 시작 일자 */
  startDate?: string;
  /** 이벤트 종료 일자 */
  endDate?: string;
  /** 이벤트 시작 및 종료시간 설정 여부. */
  isLimitedTime?: boolean;
  /** 한 줄 소개글 */
  description?: string;
  /** 이벤트 대표 이미지 fileID */
  representImage?: File;
  /** 이벤트 상세정보 타입 정의 */
  type?: string;
  /** 상세정보 본문 */
  content?: string;
  /** 첨부된 파일의 ID 배열 */
  fileIDs?: File[];
  /** (미사용) 이벤트 조회 건수 */
  viewCount?: number;
  /** (미사용) 이벤트 구매 상담 채팅 건수 */
  purchaseChatCount?: number;
  /** 병원 이벤트 통계 ID */
  stats_HospitalEventID?: string;
  /** 이벤트의 활성화 여부 */
  isActive?: boolean;
  /** 이벤트 상단 고정 여부 */
  isPinned?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 병원 ID */
  hospitalID?: string;
  /** 최초 작성자 ID */
  writerID?: UserNameAndType;
  /** 최종 수정  또는 삭제자 ID */
  modifierID?: UserNameAndType;
  /** 생성일시 */
  createdAt?: string;
  /** 수정일시. */
  modifiedAt?: string;
  /** 수정 또는 삭제일시 */
  updatedAt?: string;
}

export interface HospitalEvent {
  /** 병원 이벤트 고유 ID */
  _id?: string;
  /** 이벤트 제목 */
  title?: string;
  /** 이벤트 기본 가격 */
  price?: number;
  /** 할인율 계산 방식 정의 */
  saleType?: string;
  /** 이벤트의 정액 할인액 */
  salePrice?: number;
  /** 이벤트의 정률 할인의 할인율 */
  saleRate?: number;
  /** 이벤트 시작 일자 */
  startDate?: string;
  /** 이벤트 종료 일자 */
  endDate?: string;
  /** 이벤트 시작 및 종료시간 설정 여부. */
  isLimitedTime?: boolean;
  /** 한 줄 소개글 */
  description?: string;
  /** 이벤트 대표 이미지 fileID */
  representImage?: string;
  /** 이벤트 상세정보 타입 정의 */
  type?: string;
  /** 상세정보 본문 */
  content?: string;
  /** 상세정보 파일 이미지 fileIDs */
  fileIDs?: string;
  /** (미사용) 이벤트 조회 건수 */
  viewCount?: number;
  /** (미사용) 이벤트 구매 상담 채팅 건수 */
  purchaseChatCount?: number;
  /** 병원 이벤트 통계 ID */
  stats_HospitalEventID?: string;
  /** 이벤트의 활성화 여부 */
  isActive?: boolean;
  /** 이벤트 상단 고정 여부 */
  isPinned?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 병원 ID */
  hospitalID?: string;
  /** 최초 작성자 ID */
  writerID?: string;
  /** 최종 수정  또는 삭제자 ID */
  modifierID?: string;
  /** 생성일시 */
  createdAt?: string;
  /** 수정일시. */
  modifiedAt?: string;
  /** 수정 또는 삭제일시 */
  updatedAt?: string;
}

export interface ApiEventHospitalAftercareElFindSimpleParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /** 검색어 (상품명) */
  keyword?: string;
  /**
   * 삭제 여부
   * @default false
   */
  isRemoved?: boolean;
  /** 활성화 여부 */
  isActive?: boolean;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiEventHospitalAftercareElFindSimpleData = ApiResponse & {
  data: HospitalAftercareFindSimple[];
};

export interface ApiEventHospitalAftercareElFindOneParams {
  /** (required) 병원 홈케어 상품 _id */
  _id: string;
}

export type ApiEventHospitalAftercareElFindOneData = ApiResponse & {
  data: HospitalAftercareFileWriter;
};

export interface ApiEventHospitalAftercareElCountParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /** 검색어 (상품명) */
  keyword?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 활성화 여부 */
  isActive?: boolean;
}

export type ApiEventHospitalAftercareElCountData = ApiResponse & {
  data: number;
};

export type ApiEventHospitalAftercareElCreateData = ApiResponse & {
  data: HospitalAftercareFindSimple;
};

export type ApiEventHospitalAftercareElUpdateData = ApiResponse & {
  data: HospitalAftercareFindSimple;
};

export type ApiEventHospitalAftercareElRemoveData = ApiResponse & {
  data: HospitalAftercare;
};

export interface ApiEventHospitalAftercareHmFindOneParams {
  /** (required) 병원 홈케어 상품 _id */
  _id: string;
}

export type ApiEventHospitalAftercareHmFindOneData = ApiResponse & {
  data: HospitalAftercareFileWriter;
};

export interface ApiEventHospitalEventElFindSimpleParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /** 검색어 (이벤트 제목) */
  keyword?: string;
  /**
   * 삭제 여부
   * @default false
   */
  isRemoved?: boolean;
  /** 활성화 여부 */
  isActive?: boolean;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiEventHospitalEventElFindSimpleData = ApiResponse & {
  data: HospitalEventFindSimple[];
};

export interface ApiEventHospitalEventElFindOneParams {
  /** (required) 병원 이벤트 _id */
  _id: string;
}

export type ApiEventHospitalEventElFindOneData = ApiResponse & {
  data: HospitalEventFileWriter;
};

export interface ApiEventHospitalEventElCountParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /** 검색어 (이벤트 제목) */
  keyword?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 활성화 여부 */
  isActive?: boolean;
}

export type ApiEventHospitalEventElCountData = ApiResponse & {
  data: number;
};

export type ApiEventHospitalEventElCreateData = ApiResponse & {
  data: HospitalEventFindSimple;
};

export type ApiEventHospitalEventElUpdateData = ApiResponse & {
  data: HospitalEventFindSimple;
};

export type ApiEventHospitalEventElRemoveData = ApiResponse & {
  data: HospitalEvent;
};

export interface ApiEventHospitalEventHmFindOneParams {
  /** (required) 병원 이벤트 _id */
  _id: string;
}

export type ApiEventHospitalEventHmFindOneData = ApiResponse & {
  data: HospitalEventFileWriter;
};

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-HospitalAftercare
     * @name ApiEventHospitalAftercareElFindSimple
     * @summary 병원별 홈케어 상품 목록 조회 (상단 고정 여부, 활성화 여부, 업데이트 일시 내림차순 정렬)
     * @request GET:/v3/api/event/hospital/aftercare/el/find/simple
     * @secure
     * @response `200` `ApiEventHospitalAftercareElFindSimpleData` \[\{HospitalAftercare\}\] 정렬된 HospitalAftercare 컬렉션 객체 배열
     */
    apiEventHospitalAftercareElFindSimple: (
      query: ApiEventHospitalAftercareElFindSimpleParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalAftercareElFindSimpleData, any>({
        path: `/v3/api/event/hospital/aftercare/el/find/simple`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalAftercare
     * @name ApiEventHospitalAftercareElFindOne
     * @summary 병원별 홈케어 상품 상세 조회
     * @request GET:/v3/api/event/hospital/aftercare/el/find/one
     * @secure
     * @response `200` `ApiEventHospitalAftercareElFindOneData` \{HospitalAftercare\} 병원 홈케어 상품 객체
     */
    apiEventHospitalAftercareElFindOne: (query: ApiEventHospitalAftercareElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalAftercareElFindOneData, any>({
        path: `/v3/api/event/hospital/aftercare/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalAftercare
     * @name ApiEventHospitalAftercareElCount
     * @summary 병원별 홈케어 상품 목록 수 조회
     * @request GET:/v3/api/event/hospital/aftercare/el/count
     * @secure
     * @response `200` `ApiEventHospitalAftercareElCountData` \[\{HospitalAftercare\}\] 선택한 HospitalID 대한 HospitalAftercare 수
     */
    apiEventHospitalAftercareElCount: (query: ApiEventHospitalAftercareElCountParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalAftercareElCountData, any>({
        path: `/v3/api/event/hospital/aftercare/el/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalAftercare
     * @name ApiEventHospitalAftercareElCreate
     * @summary 병원별 홈케어 상품 생성
     * @request POST:/v3/api/event/hospital/aftercare/el/create
     * @secure
     * @response `200` `ApiEventHospitalAftercareElCreateData` \{HospitalAftercare\} 생성된 병원 홈케어 상품 객체
     */
    apiEventHospitalAftercareElCreate: (
      data: {
        /** (required) 홈케어 상품 이름 */
        title: string;
        /** (required) 기본가 */
        price: number;
        /** (optional) 할인가, saleType이 price인 경우 기준점 */
        salePrice?: number;
        /** (optional) 할인율, saleType이 rate인 경우 기준점 */
        saleRate?: number;
        /** (required) 할인가격 적용 방식. 정액 할인액(price), 정률 할인의 할인율(rate) */
        saleType: string;
        /** (optional) 홈케어 상품 시작 및 종료시간 설정 여부. 기한 없을 시 false */
        isLimitedTime?: boolean;
        /** (optional) 한 줄 소개글 */
        description?: string;
        /** (required) 대표 이미지 FileID */
        representImage: string;
        /**
         * (optional) 홈케어 상품 판매 기간 시작 날짜
         * @default "2023-04-17"
         */
        startDate?: string;
        /**
         * (optional) 홈케어 상품 판매 기간 종료 날짜
         * @default "2023-04-23"
         */
        endDate?: string;
        /** (required) 병원 ObjectId */
        hospitalID: string;
        /** (required) 홈케어 상품 상세정보 타입 .. 텍스트 팝업 (text), 이미지 팝업 (image) */
        type: string;
        /** (optional) 홈케어 상품 상세정보 타입이 텍스트 일때, 본문 내용 */
        content?: string;
        /** (optional) 홈케어 상품 상세정보 타입이 이미지 일때, 이미지 내용 */
        fileIDs?: string[];
        /** (optional) 홈케어 상품의 활성화 여부 */
        isActive?: boolean;
        /** (optional) 홈케어 상품 상단 고정 여부 */
        isPinned?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalAftercareElCreateData, any>({
        path: `/v3/api/event/hospital/aftercare/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalAftercare
     * @name ApiEventHospitalAftercareElUpdate
     * @summary 병원별 홈케어 상품 업데이트
     * @request POST:/v3/api/event/hospital/aftercare/el/update
     * @secure
     * @response `200` `ApiEventHospitalAftercareElUpdateData` \{HospitalAftercare\} 업데이트된 HospitalAftercare 객체
     */
    apiEventHospitalAftercareElUpdate: (
      data: {
        /** (required) 수정할 홈케어 상품 ObjectId */
        _id: string;
        /** (optional) 홈케어 상품 이름 */
        title?: string;
        /** (optional) 기본가 */
        price?: number;
        /** (optional) 할인가, saleType이 price인 경우 기준점 */
        salePrice?: number;
        /** (optional) 할인율, saleType이 rate인 경우 기준점 */
        saleRate?: number;
        /** (optional) 할인가격 적용 방식. 정액 할인액(price), 정률 할인의 할인율(rate) */
        saleType?: string;
        /** (optional) 홈케어 상품 시작 및 종료시간 설정 여부. 기한 없을 시 false */
        isLimitedTime?: boolean;
        /** (optional) 한 줄 소개글 */
        description?: string;
        /** (optional) 대표 이미지 FileID */
        representImage?: string;
        /**
         * (optional) 홈케어 상품 판매 기간 시작 날짜
         * @default "2023-04-17"
         */
        startDate?: string;
        /**
         * (optional) 홈케어 상품 판매 기간 종료 날짜
         * @default "2023-04-23"
         */
        endDate?: string;
        /** (optional) 병원 ObjectId */
        hospitalID?: string;
        /** (optional) 홈케어 상품 상세정보 타입 .. 텍스트 팝업 (text), 이미지 팝업 (image) */
        type?: string;
        /** (optional) 홈케어 상품 상세정보 타입이 텍스트 일때, 본문 내용 */
        content?: string;
        /** (optional) 홈케어 상품 상세정보 타입이 이미지 일때, 이미지 내용 */
        fileIDs?: string[];
        /** (optional) 홈케어 상품의 활성화 여부 */
        isActive?: boolean;
        /** (optional) 홈케어 상품 상단 고정 여부 */
        isPinned?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalAftercareElUpdateData, any>({
        path: `/v3/api/event/hospital/aftercare/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalAftercare
     * @name ApiEventHospitalAftercareElRemove
     * @summary 병원별 홈케어상품 삭제
     * @request POST:/v3/api/event/hospital/aftercare/el/remove
     * @secure
     * @response `200` `ApiEventHospitalAftercareElRemoveData` \{HospitalAftercare\} 삭제된 HospitalAftercare 객체
     */
    apiEventHospitalAftercareElRemove: (
      data: {
        /** (required) 삭제할 홈케어 상품 ObjectId */
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalAftercareElRemoveData, any>({
        path: `/v3/api/event/hospital/aftercare/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalAftercare
     * @name ApiEventHospitalAftercareHmFindOne
     * @summary 병원 상담 모바일 앱 - 병원별 홈케어 상품 상세 조회
     * @request GET:/v3/api/event/hospital/aftercare/hm/find/one
     * @secure
     * @response `200` `ApiEventHospitalAftercareHmFindOneData` \{HospitalAftercare\} 병원 홈케어 상품 객체
     */
    apiEventHospitalAftercareHmFindOne: (query: ApiEventHospitalAftercareHmFindOneParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalAftercareHmFindOneData, any>({
        path: `/v3/api/event/hospital/aftercare/hm/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalEvent
     * @name ApiEventHospitalEventElFindSimple
     * @summary 병원별 이벤트 간단 목록 조회 (상단 고정 여부, 활성화 여부, 업데이트 일시 내림차순 정렬)
     * @request GET:/v3/api/event/hospital/event/el/find/simple
     * @secure
     * @response `200` `ApiEventHospitalEventElFindSimpleData` \[\{HospitalEvent\}\] 정렬된 HospitalEvent 컬렉션 객체 배열
     */
    apiEventHospitalEventElFindSimple: (query: ApiEventHospitalEventElFindSimpleParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalEventElFindSimpleData, any>({
        path: `/v3/api/event/hospital/event/el/find/simple`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalEvent
     * @name ApiEventHospitalEventElFindOne
     * @summary 병원별 이벤트 상세 조회
     * @request GET:/v3/api/event/hospital/event/el/find/one
     * @secure
     * @response `200` `ApiEventHospitalEventElFindOneData` \{HospitalEvent\} 병원 이벤트 객체
     */
    apiEventHospitalEventElFindOne: (query: ApiEventHospitalEventElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalEventElFindOneData, any>({
        path: `/v3/api/event/hospital/event/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalEvent
     * @name ApiEventHospitalEventElCount
     * @summary 병원별 이벤트 목록 수 조회
     * @request GET:/v3/api/event/hospital/event/el/count
     * @secure
     * @response `200` `ApiEventHospitalEventElCountData` \[\{HospitalEvent\}\] 선택한 HospitalID 대한 HospitalEvent 수
     */
    apiEventHospitalEventElCount: (query: ApiEventHospitalEventElCountParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalEventElCountData, any>({
        path: `/v3/api/event/hospital/event/el/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalEvent
     * @name ApiEventHospitalEventElCreate
     * @summary 병원별 이벤트 생성
     * @request POST:/v3/api/event/hospital/event/el/create
     * @secure
     * @response `200` `ApiEventHospitalEventElCreateData` \{HospitalEvent\} 생성된 병원 이벤트 객체
     */
    apiEventHospitalEventElCreate: (
      data: {
        /** (required) 이벤트 이름 */
        title: string;
        /** (required) 기본가 */
        price: number;
        /** (optional) 할인가, saleType이 price인 경우 기준점 */
        salePrice?: number;
        /** (optional) 할인율, saleType이 rate인 경우 기준점 */
        saleRate?: number;
        /** (required) 할인가격 적용 방식. 정액 할인액(price), 정률 할인의 할인율(rate) */
        saleType: string;
        /** (optional) 이벤트 시작 및 종료시간 설정 여부. 기한 없을 시 false */
        isLimitedTime?: boolean;
        /** (optional) 한 줄 소개글 */
        description?: string;
        /** (required) 대표 이미지 FileID */
        representImage: string;
        /**
         * (optional) 이벤트 기간 시작 날짜
         * @default "2023-04-17"
         */
        startDate?: string;
        /**
         * (optional) 이벤트 기간 종료 날짜
         * @default "2023-04-23"
         */
        endDate?: string;
        /** (required) 병원 ObjectId */
        hospitalID: string;
        /** (required) 이벤트 상세정보 타입 .. 텍스트 팝업 (text), 이미지 팝업 (image) */
        type: string;
        /** (optional) 이벤트 상세정보 타입이 텍스트 일때, 본문 내용 */
        content?: string;
        /** (optional) 이벤트 상세정보 타입이 이미지 일때, 이미지 내용 */
        fileIDs?: string[];
        /** (optional) 이벤트의 활성화 여부 */
        isActive?: boolean;
        /** (optional) 이벤트 상단 고정 여부 */
        isPinned?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalEventElCreateData, any>({
        path: `/v3/api/event/hospital/event/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalEvent
     * @name ApiEventHospitalEventElUpdate
     * @summary 병원별 이벤트 업데이트
     * @request POST:/v3/api/event/hospital/event/el/update
     * @secure
     * @response `200` `ApiEventHospitalEventElUpdateData` \{HospitalEvent\} 업데이트된 HospitalEvent 객체
     */
    apiEventHospitalEventElUpdate: (
      data: {
        /** (required) 수정할 이벤트 ObjectId */
        _id: string;
        /** (optional) 이벤트 이름 */
        title?: string;
        /** (optional) 기본가 */
        price?: number;
        /** (optional) 할인가, saleType이 price인 경우 기준점 */
        salePrice?: number;
        /** (optional) 할인율, saleType이 rate인 경우 기준점 */
        saleRate?: number;
        /** (optional) 할인가격 적용 방식. 정액 할인액(price), 정률 할인의 할인율(rate) */
        saleType?: string;
        /** (optional) 이벤트 시작 및 종료시간 설정 여부. 기한 없을 시 false */
        isLimitedTime?: boolean;
        /** (optional) 한 줄 소개글 */
        description?: string;
        /** (optional) 대표 이미지 FileID */
        representImage?: string;
        /**
         * (optional) 이벤트 기간 시작 날짜
         * @default "2023-04-17"
         */
        startDate?: string;
        /**
         * (optional) 이벤트 기간 종료 날짜
         * @default "2023-04-23"
         */
        endDate?: string;
        /** (optional) 병원 ObjectId */
        hospitalID?: string;
        /** (optional) 이벤트 상세정보 타입 .. 텍스트 팝업 (text), 이미지 팝업 (image) */
        type?: string;
        /** (optional) 이벤트 상세정보 타입이 텍스트 일때, 본문 내용 */
        content?: string;
        /** (optional) 이벤트 상세정보 타입이 이미지 일때, 이미지 내용 */
        fileIDs?: string[];
        /** (optional) 이벤트의 활성화 여부 */
        isActive?: boolean;
        /** (optional) 이벤트 상단 고정 여부 */
        isPinned?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalEventElUpdateData, any>({
        path: `/v3/api/event/hospital/event/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalEvent
     * @name ApiEventHospitalEventElRemove
     * @summary 병원별 이벤트 삭제
     * @request POST:/v3/api/event/hospital/event/el/remove
     * @secure
     * @response `200` `ApiEventHospitalEventElRemoveData` \{HospitalEvent\} 삭제된 HospitalEvent 객체
     */
    apiEventHospitalEventElRemove: (
      data: {
        /** (required) 삭제할 이벤트 ObjectId */
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiEventHospitalEventElRemoveData, any>({
        path: `/v3/api/event/hospital/event/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalEvent
     * @name ApiEventHospitalEventHmFindOne
     * @summary 병원 상담 모바일 앱 - 병원별 이벤트 상세 조회
     * @request GET:/v3/api/event/hospital/event/hm/find/one
     * @secure
     * @response `200` `ApiEventHospitalEventHmFindOneData` \{HospitalEvent\} 병원 이벤트 객체
     */
    apiEventHospitalEventHmFindOne: (query: ApiEventHospitalEventHmFindOneParams, params: RequestParams = {}) =>
      this.request<ApiEventHospitalEventHmFindOneData, any>({
        path: `/v3/api/event/hospital/event/hm/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
